// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1unS7","left":"styles_left__2P3MB","desktopActions":"styles_desktopActions__2hC0l","title":"styles_title__cwKHh"};